import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import MaskedInput from 'react-text-mask';
import DefaultSettings from '../../controls/components/settings';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['+','(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
            guide={false}
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,

};

function formatText(text) {
    if (text) {
        if (this.props.mask === 'phone')
            return text.replace(/[^A-Z0-9]/ig, "");
        if (this.props.mask === 'amount')
            return text
        return text
    }
    return undefined
}

export default function FormattedInputs(props) {


    //   console.log(props)
    const { handleFieldChange, value, tooltip, name, id, edit, options, conditions, disabled, required, contexthelp, ...otherProps } = props
    let disabledstatus = conditions && conditions.enable ? conditions.enable : disabled
    const { label, xtype, inputProps, password, error, helperText } = otherProps
    const val = ((value === null) || (value === undefined)) ? '' : value
    if (edit === true) {
        let tlabel = <Typography variant={value || disabled ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
            {tooltip && <Tooltip title={tooltip ? tooltip : null}
                placement="bottom-start" >
                <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                    onClick={(evt) => contexthelp ?
                        DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
            </Tooltip>}
        </Typography>
        return (
            <div >
                <FormControl fullWidth error={error} >
                    <InputLabel >{tlabel}</InputLabel>
                    <Input
                        name={name}
                        value={edit ? val : `+${val}`}
                        onBlur={handleFieldChange}
                        id="formatted-text-mask-input"
                        style={{ fontWeight: 500 }}
                        //required={required}
                        label={tlabel}
                        inputComponent={TextMaskCustom}
                        // InputLabelProps={{
                        //     shrink: true,s
                        // }}
                        disabled={disabled}
                    />
                    {helperText && <FormHelperText >{helperText}</FormHelperText>}
                </FormControl>

            </div>
        );
    }
    else {
        return (
            <div >
                {tooltip && <Fragment><Typography variant={'subtitle1'} >{label}&nbsp;< Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
                    <HelpOutlineIcon fontSize="small" style={{ width: '0.8em' }} />
                </Tooltip> </Typography>  <Typography variant={'subtitle2'} color={'black'}>{val}   </Typography></Fragment>}
                {!tooltip && <Fragment><Typography variant={'subtitle1'} >{label} </Typography>
                    <Typography variant={'subtitle2'} color={'black'}>{val}   </Typography></Fragment>}
            </div>
        );
    }
}

FormattedInputs.propTypes = {
    handleFieldChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    edit: PropTypes.bool,
    options: PropTypes.object,
    conditions: PropTypes.object,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    contexthelp: PropTypes.string,
    label: PropTypes.string,
    xtype: PropTypes.string,
    inputProps: PropTypes.object,
    password: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    value: PropTypes.string
};